import { prepareMonthlyHoroscopeCategory } from "./horoscope.jsx"

document.addEventListener("turbo:load", function () {
  // หน้าหมวดเดี่ยว (ลิงก์ตรง) 1 การ์ด · หน้าเดือนที่ปลดล็อกแล้ว 5 การ์ดเรียงยาว
  const cards = document.querySelectorAll(
    "#horoscope-monthly-topic .category-card, #horoscope-monthly-show .category-card"
  )
  cards.forEach((card) => prepareMonthlyHoroscopeCategory(card))
})
